import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import {
  vendorsService,
  type CreateVendorInput,
  type UpdateVendorInput,
} from "../../services/admin/vendors.service";

export function useVendorsAdmin() {
  return useQuery({
    queryKey: ["vendors-admin"],
    queryFn: () => vendorsService.getAll(),
  });
}

export function useCreateVendor() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (input: CreateVendorInput) => vendorsService.create(input),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["vendors-admin"] });
      queryClient.invalidateQueries({ queryKey: ["vendors"] });
      queryClient.invalidateQueries({ queryKey: ["active-vendors"] });
    },
  });
}

export function useUpdateVendor() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (input: UpdateVendorInput) => vendorsService.update(input),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["vendors-admin"] });
      queryClient.invalidateQueries({ queryKey: ["vendors"] });
      queryClient.invalidateQueries({ queryKey: ["active-vendors"] });
    },
  });
}

export function useToggleVendorActive() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => vendorsService.toggleActive(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["vendors-admin"] });
      queryClient.invalidateQueries({ queryKey: ["vendors"] });
      queryClient.invalidateQueries({ queryKey: ["active-vendors"] });
    },
  });
}
